import { Box } from '@mui/material';
import QuizHeader from '../../common/QuizHeader';
import QuizQuestion from '../../common/QuizQuestion';
import QuizContainer from '../../common/QuizContainer';
import QuizButton, { ButtonType } from '../../common/QuizButton';
import { useQuizState } from '../../../providers/QuizProvider/QuizProvider.hooks';
import { BLOOD_PRESSUE_ANSWERS, BloodPressure, LIVING_AREA_ANSWERS, LivingArea } from '../../../providers/QuizProvider/QuizProvider.types';
import QuizStepBackgroundWrapper from '../../common/QuizStepBackgroundWrapper';

function Step13() {
  const { setStep, setQuizData } = useQuizState();
  const handleClick = (type: LivingArea) => {
    setQuizData((prev) => ({
      ...prev,
      livingArea: type,
    }));
    setStep((prev) => prev + 1);
  };

  return (
    <QuizStepBackgroundWrapper>
      <QuizHeader
        onBack={() => {
          setStep((prev) => prev - 1);
        }}
        stepNumber={13}
        stepsNumber={19}
      ></QuizHeader>
      <QuizQuestion text="Which best describes the area where you live?"></QuizQuestion>
      <QuizContainer>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '30px',
          }}
        >
          {Object.keys(LIVING_AREA_ANSWERS).map((key) => (
            <QuizButton
              key={key}
              onClick={() => handleClick(key as keyof typeof LIVING_AREA_ANSWERS)}
              variant={ButtonType.WHITE}
              text={LIVING_AREA_ANSWERS[key as keyof typeof LIVING_AREA_ANSWERS]}
            ></QuizButton>
          ))}
        </Box>
      </QuizContainer>
    </QuizStepBackgroundWrapper>
  );
}

export default Step13;
